import { render, staticRenderFns } from "./TownList.vue?vue&type=template&id=d699eb30&scoped=true&"
import script from "./TownList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TownList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TownList.vue?vue&type=style&index=0&id=d699eb30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d699eb30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d699eb30')) {
      api.createRecord('d699eb30', component.options)
    } else {
      api.reload('d699eb30', component.options)
    }
    module.hot.accept("./TownList.vue?vue&type=template&id=d699eb30&scoped=true&", function () {
      api.rerender('d699eb30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/ChooseTownDialog/components/TownList.vue"
export default component.exports